import React from 'react';

export default function Table({
  columns,
  data = [],
  filters,
  actions,
  emptyMessage = 'No records found.',
  emptyAction,
  pagination
}) {
  const rows = data || [];
  const hasRows = rows.length > 0;
  const limit = pagination?.limit ?? rows.length;
  const offset = pagination?.offset ?? 0;
  const hasNext = pagination?.hasNext ?? (limit > 0 && rows.length === limit);
  const hasPrev = offset > 0;
  const start = hasRows ? offset + 1 : 0;
  const end = offset + rows.length;

  const handlePrev = () => {
    if (!pagination?.onPageChange) return;
    const nextOffset = Math.max(0, offset - (limit || 0));
    pagination.onPageChange(nextOffset);
  };

  const handleNext = () => {
    if (!pagination?.onPageChange) return;
    pagination.onPageChange(offset + (limit || 0));
  };

  const showToolbar = !!filters || !!actions;
  const showPagination = !!pagination;

  return (
    <div className="table-shell">
      {showToolbar ? (
        <div className="table-toolbar">
          {filters ? <div className="table-filters">{filters}</div> : <div />}
          {actions ? <div className="table-actions">{actions}</div> : null}
        </div>
      ) : null}
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {hasRows ? (
              rows.map((row, idx) => (
                <tr key={idx}>
                  {columns.map((col) => (
                    <td key={col.key}>{row[col.key]}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td className="table-empty" colSpan={Math.max(columns.length, 1)}>
                  <div className="table-empty-title">{emptyMessage}</div>
                  {emptyAction ? <div className="table-empty-action">{emptyAction}</div> : null}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showPagination ? (
        <div className="table-pagination">
          <div className="table-pagination-info">
            {hasRows ? `Showing ${start}-${end}` : 'No results'}
            {typeof pagination.total === 'number' ? ` of ${pagination.total}` : ''}
          </div>
          <div className="table-pagination-controls">
            <button className="btn btn-ghost btn-sm" type="button" onClick={handlePrev} disabled={!hasPrev}>
              Previous
            </button>
            <button className="btn btn-ghost btn-sm" type="button" onClick={handleNext} disabled={!hasNext}>
              Next
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
